import { makeProjectionStateField } from "components/organisms/manuscript/editor/latex/completion/support/projection-state-field";
import { enterNode } from "components/organisms/manuscript/editor/latex/completion/support/tree-operations/commands";
export const documentCommands = makeProjectionStateField(enterNode);
